import axios from "axios";
import { baseURL } from "../../../base-url.js";

export default {
  async addMoney(_, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.put(`${baseURL}/cashRegister/addMoney`, null, {
        params: {
          value: params.amount,
          assignedEmployeeId: params.assignedEmployeeId,
          assignedSalonId: params.assignedSalonId
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async withdrawMoney(_, params) {
    const token = localStorage.getItem("jwt");

    try {
      const response = await axios.put(`${baseURL}/cashRegister/withdrawMoney`, null, {
        params: {
          value: params.amount,
          assignedEmployeeId: params.assignedEmployeeId,
          assignedSalonId: params.assignedSalonId
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  async loadOperationsHistory({ commit }, params) {
    const token = localStorage.getItem("jwt");
    try {
      const response = await axios.get(`${baseURL}/cashRegister/getOperationsHistory`, {
        params: {
          salonId: params.salonId,
          page: params.page,
          size: params.size
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      commit('setCashRegisterOperations', response.data);
      return response.data;
    } catch (error) {
      return error.response;
    }
  }


}
